<template>
    <div v-if="$root.isMobile" class="mobile-page-title">
        <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-primary btn-sm" @click="showFilters = true">
                <i class="fal fa-sliders-h"></i> Filtri
            </button>
            <h4 class="mb-0 font-weight-bold flex-grow-1 text-center">
                Agenti
            </h4>
            <button type="button" class="btn btn-success btn-sm" @click="creaAgente()">
                <i class="fas fa-plus ml-2"></i>
            </button>
        </div>
    </div>
    <div class="kt-portlet__head">
        <div v-if="$root.isMobile">
            <div class="offcanvas-backdrop" :class="{ show: showFilters }" @click.self="showFilters = false">
                <aside class="offcanvas-panel" :class="{ open: showFilters }" role="dialog" aria-modal="true">
                    <div class="offcanvas-header" style="background: linear-gradient(135deg,#3434D9,#34A8D9);">
                        <h6 class="mb-0 text-light"><i class="fal fa-filter"></i> Filtri ricerca</h6>
                        <button type="button" class="btn btn-light btn-sm" @click="showFilters = false">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="offcanvas-body">
                        <form class="isprint-filter" autocomplete="off" @submit.prevent>
                            <div class="mb-3">
                                <label class="mb-1">Codice Agente</label>
                                <input class="form-control form-control-sm" placeholder="Codice Agente"
                                    v-model="search.CODICE_AGENTE.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Area di competenza</label>
                                <input class="form-control form-control-sm" placeholder="Area di Competenza"
                                    v-model="search.AREA_DI_COMPETENZA.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Agente</label>
                                <input class="form-control form-control-sm" placeholder="Descrizione Agente"
                                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Dovuto</label>
                                <input class="form-control form-control-sm" placeholder="Importo dovuto"
                                    v-model="search.DOVUTO.VALUE">
                            </div>

                            <div class="mb-3">
                                <label class="mb-1">Fattore</label>
                                <input class="form-control form-control-sm" placeholder="Fattore"
                                    v-model="search.FATTORE_AG.VALUE">
                            </div>
                            <div class="form-group">
                                <label>Pagate</label><br>
                                <select class="form-control form-control-sm" style="width: 150px;"
                                    v-model="search.PAGATO.VALUE">
                                    <option value="">Tutti</option>
                                    <option value="0">Da Pagare</option>
                                    <option value="1">Pagate</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Tipologia Agente</label><br>
                                <select class="form-control form-control-sm" style="width: 150px;"
                                    v-model="search.LIVELLO.VALUE">
                                    <option value="">Tutti</option>
                                    <option value="1">Agenti</option>
                                    <option value="2">Procacciatori</option>
                                    <option value="3">Segnalatori</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>

        <form v-else class="isprint-filter" autocomplete="off">
            <div class="form-group">
                <label>Codice Agente</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Codice Agente"
                    type="text" style="width:150px" v-model="search.CODICE_AGENTE.VALUE">
            </div>
            <div class="form-group">
                <label>Area di competenza</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                    placeholder="Area di Competenza" type="text" style="width:150px"
                    v-model="search.AREA_DI_COMPETENZA.VALUE">
            </div>
            <div class="form-group">
                <label>Agente</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd"
                    placeholder="Descrizione Agente" type="text" style="width:150px"
                    v-model="search.DESCRIZIONE_AGENTE.VALUE">
            </div>
            <div class="form-group">
                <label>Dovuto</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Dovuto"
                    type="text" style="width:150px" v-model="search.DOVUTO.VALUE">
            </div>
            <div class="form-group">
                <label>Fattore</label><br />
                <input class="form-control form-control-sm" autocomplete="off" name="adasd" placeholder="Fattore"
                    type="text" style="width:150px" v-model="search.FATTORE_AG.VALUE">
            </div>
            <div class="form-group">
                <label>Pagate</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.PAGATO.VALUE">
                    <option value="">Tutti</option>
                    <option value="0">Da Pagare</option>
                    <option value="1">Pagate</option>
                </select>
            </div>
            <div class="form-group">
                <label>Tipologia Agente</label><br>
                <select class="form-control form-control-sm" style="width: 150px;" v-model="search.LIVELLO.VALUE">
                    <option value="">Tutti</option>
                    <option value="1">Agenti</option>
                    <option value="2">Procacciatori</option>
                    <option value="3">Segnalatori</option>
                </select>
            </div>
            <button class="btn btn-primary float-right btn-sm my-2 my-sm-3" v-on:click="creaAgente()"
                style="margin-top:26px"><i class="fal fa-plus"></i> Crea Agente</button>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="esportaAgenti()"
                style="margin-top:26px"><i class="fal fa-file-excel"></i> Esporta Agenti</button>
        </form>
    </div>
    <div class="isprint-grid-container">
        <div v-if="$root.isMobile" class="row justify-content-center">
            <div class="col-12 mb-4" v-for="agente in paginatedList.arr" :key="agente.ID_AGENTE">
                <div class="card shadow border-0 text-center p-3" style="border-radius: 20px;">
                    <div class="card-body">
                        <i class="fad fa-user-secret fa-6x mb-3" aria-hidden="true"></i>

                        <h5 class="card-title">
                            {{ agente.DESCRIZIONE_AGENTE }}<br>
                            <span v-if="agente.LIVELLO === 2" class="badge badge-info ml-2">PROCACCIATORE</span>
                            <span v-if="agente.LIVELLO === 3" class="badge badge-secondary ml-2">SEGNALATORE</span>
                        </h5>

                        <p class="mb-1"><strong>Codice:</strong> {{ agente.CODICE_AGENTE }}</p>

                        <!-- Gettone - solo per LIVELLO 1 -->
                        <p v-if="agente.LIVELLO === 1" class="mb-1">
                            <strong>Gettone:</strong> {{ agente.GETTONE_AG }}€
                        </p>

                        <!-- Fattore - solo per LIVELLO 1 -->
                        <p v-if="agente.LIVELLO === 1" class="mb-1">
                            <strong>Fattore:</strong> {{ agente.FATTORE_AG }}€
                        </p>

                        <!-- Dovuto - solo per LIVELLO 1 -->
                        <div v-if="agente.LIVELLO === 1">
                            <p class="mb-2"><strong>Dovuto:</strong></p>
                            <div>
                                <h2 class="d-inline">{{ agente.DOVUTO }}</h2>
                                <i class="fad fa-euro-sign"></i>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between mt-3">
                            <button class="btn btn-info btn-sm" @click="moreInfo(agente)" title="Info agente">
                                <i class="fal fa-info-circle"></i>
                            </button>
                            <button class="btn btn-success btn-sm" @click="esportaDettaglioAgente(agente)" title="Esporta dettaglio">
                                <i class="fal fa-file-excel"></i>
                            </button>
                            <button class="btn btn-warning btn-sm" @click="modificaAgente(agente)"
                                title="Modifica agente">
                                <i class="fal fa-pencil"></i>
                            </button>
                            <button class="btn btn-danger btn-sm" @click="deleteAgente(agente)" title="Elimina agente">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <table v-else class="isprint-grid shadow">
            <thead class="isprint-grid-thead" style="border-right : none !important; ">
                <tr style="left: 0px; background: linear-gradient(135deg,#3434D9,#34A8D9); color:#fff;">
                    <th rowspan="3" style="width:18%;text-align: center; border-right: 2px solid #fff;"><span>Agente</span></th>
                    <th colspan="3" style="width:30%;text-align:center; border-right: 2px solid #fff; border-bottom: 2px solid #fff;"><span><i class="fas fa-gas-pump text-danger fa-2x mt-2 mb-2"></i></span></th>
                    <th colspan="3" style="width:30%;text-align:center; border-right: 2px solid #fff; border-bottom: 2px solid #fff;"><span><i class="fas fa-lightbulb text-warning fa-2x mt-2 mb-2"></i></span></th>
                    <th rowspan="3" style="width:6%; text-align: center; border-right: 2px solid #fff;"><span>Pagate</span></th>
                    <th rowspan="3" style="width:6%; text-align: center; border-right: 2px solid #fff;"><span>Dovuto</span></th>
                    <th rowspan="3" style="width:12%; text-align: center;"><span>Azioni</span></th>
                </tr>
                <tr style="left: 0px; background: linear-gradient(135deg,#3434D9,#34A8D9); color:#fff;">
                    <th rowspan="2" style="text-align: center;width:10%; border-right: 2px solid #fff; font-size:11px;"><span>Fattore</span></th>
                    <th colspan="2" style="text-align: center;width:20%; border-right: 2px solid #fff; border-bottom: 2px solid #fff; font-size:11px;"><span>Commissioni</span></th>
                    <th rowspan="2" style="text-align: center;width:10%; border-right: 2px solid #fff; font-size:11px;"><span>Gettone</span></th>
                    <th colspan="2" style="text-align: center;width:20%; border-right: 2px solid #fff; border-bottom: 2px solid #fff; font-size:11px;"><span>Commissioni</span></th>
                </tr>
                <tr style="left: 0px; background: linear-gradient(135deg,#3434D9,#34A8D9); color:#fff;">
                    <th style="text-align: center;width:10%; font-size:10px;"><span>Totali</span></th>
                    <th style="text-align: center;width:10%; border-right: 2px solid #fff; font-size:10px;"><span>Maturate</span></th>
                    <th style="text-align: center;width:10%; font-size:10px;"><span>Totali</span></th>
                    <th style="text-align: center;width:10%; border-right: 2px solid #fff; font-size:10px;"><span>Maturate</span></th>
                </tr>
            </thead>

            <tbody class="isprint-grid-tbody" style="font-size:13px !important;">
                <tr style="left: 0px;height:50px" v-for="agente in paginatedList.arr" v-bind:key="agente.ID_AGENTE">
                    <!-- AGENTE (CODICE + NOME) -->
                    <td style="width:18%; border-right: 2px solid #fff; border-left: 2px solid #fff; vertical-align: middle;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div>
                                <div class="mb-1">
                                    <kbd style="font-size:11px; padding: 2px 6px;">{{ agente.CODICE_AGENTE }}</kbd>
                                    <span v-if="agente.LIVELLO === 2" class="badge badge-info badge-sm ml-1">PR</span>
                                    <span v-if="agente.LIVELLO === 3" class="badge badge-secondary badge-sm ml-1">SG</span>

                                    <i v-show="agente.IS_BIRTHDAY == true" class="fad fa-birthday-cake"
                                        style="margin-left: 6px;--fa-primary-color: #C4AC21; --fa-secondary-color: #FF0000;"
                                        aria-hidden="true"></i>
                                </div>
                                <strong style="font-size:14px">{{ agente.DESCRIZIONE_AGENTE }}</strong>
                            </div>
                            <button data-toggle="tooltip" data-placement="top" title="Esporta dettaglio provvigioni"
                                class="btn btn-success btn-sm" v-on:click="esportaDettaglioAgente(agente)">
                                <i class="fal fa-file-excel"></i>
                            </button>
                        </div>

                    </td>

                    <!-- ========== SEZIONE GAS ========== -->
                    <!-- FATTORE GAS -->
                    <td class="bg-gas" style="width:10%; text-align: center; border-right: 1px solid #fff; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:14px;">{{ agente.FATTORE_AG }}€</strong>
                    </td>

                    <!-- COMMISSIONI GAS TOTALI -->
                    <td class="bg-gas" style="width:10%; text-align: center; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:13px;">{{ agente.COMMISSIONI_TOTALI_GAS }}€</strong>
                    </td>

                    <!-- COMMISSIONI GAS MATURATE -->
                    <td class="bg-gas" style="width:10%; text-align: center; border-right: 2px solid #fff; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:13px; color:#28a745;">{{ agente.COMMISSIONI_MATURATE_GAS }}€</strong>
                    </td>

                    <!-- ========== SEZIONE LUCE ========== -->
                    <!-- GETTONE LUCE -->
                    <td class="bg-luce" style="width:10%; border-right: 1px solid #fff; vertical-align: middle;">
                        <div v-if="agente.LIVELLO === 1" style="display: flex; align-items: center; justify-content: center; position: relative; padding: 0 8px;">
                            <strong style="font-size:14px;">{{ agente.GETTONE_AG }}€</strong>
                            <button class="btn btn-sm btn-outline-warning" @click="modificaAllGettoni(agente)" title="Modifica gettone per tutti i contratti" style="position: absolute; right: 8px;">
                                <i class="fal fa-edit"></i>
                            </button>
                        </div>
                    </td>

                    <!-- COMMISSIONI LUCE TOTALI -->
                    <td class="bg-luce" style="width:10%; text-align: center; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:13px;">{{ agente.COMMISSIONI_TOTALI_LUCE }}€</strong>
                    </td>

                    <!-- COMMISSIONI LUCE MATURATE -->
                    <td class="bg-luce" style="width:10%; text-align: center; border-right: 2px solid #fff; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:13px; color:#28a745;">{{ agente.COMMISSIONI_MATURATE_LUCE }}€</strong>
                    </td>

                    <!-- PROVVIGIONI PAGATE -->
                    <td style="width:6%; text-align: center; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" style="font-size:13px;">{{ agente.PROVVIGIONI_PAGATE }}€</strong>
                    </td>

                    <!-- DOVUTO TOTALE -->
                    <td style="width:6%; text-align: center; vertical-align: middle;">
                        <strong v-if="agente.LIVELLO === 1" :class="{'text-success': agente.DOVUTO <= 0, 'text-danger': agente.DOVUTO > 0}" style="font-size:14px;">{{ agente.DOVUTO }}€</strong>
                    </td>

                    <!-- AZIONI -->
                    <td style="width:12%; text-align: center; vertical-align: middle;">
                        <div class="btn-group btn-group-sm" role="group">
                            <button data-toggle="tooltip" data-placement="top" title="Info agente"
                                class="btn btn-info btn-sm" v-on:click="moreInfo(agente)">
                                <i class="fal fa-info-circle"></i>
                            </button>

                            <button data-toggle="tooltip" data-placement="top" title="Modifica agente"
                                class="btn btn-warning btn-sm" v-on:click="modificaAgente(agente)">
                                <i class="fal fa-pencil"></i>
                            </button>
                            <button data-toggle="tooltip" data-placement="top" title="Elimina agente"
                                class="btn btn-danger btn-sm" v-on:click="deleteAgente(agente)">
                                <i class="fal fa-trash-alt"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count"
            :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>


    <!-- MODALE  -->
    <div class="modal fade" id="popUpAgente" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header" style="background: linear-gradient(135deg,#3434D9,#34A8D9);">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-user-secret fa-fw"></i> Agente</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <!-- STEP 1: Selezione Tipologia con Card -->
                    <div v-if="!agenteSelezionato.LIVELLO" class="row">
                        <div class="col-12 mb-3">
                            <h5 class="text-center mb-4">Seleziona la tipologia</h5>
                        </div>

                        <!-- Card Agente -->
                        <div class="col-md-4">
                            <div class="card card-selectable text-center" v-on:click="selezionaTipologia(1)"
                                style="cursor: pointer; transition: all 0.3s;">
                                <div class="card-body">
                                    <i class="fad fa-user-tie fa-4x mb-3" style="color: #3434D9;"></i>
                                    <h5 class="card-title">Agente</h5>
                                    <p class="card-text text-muted">Gestione completa con provvigioni e area</p>
                                </div>
                            </div>
                        </div>

                        <!-- Card Procacciatore -->
                        <div class="col-md-4">
                            <div class="card card-selectable text-center" v-on:click="selezionaTipologia(2)"
                                style="cursor: pointer; transition: all 0.3s;">
                                <div class="card-body">
                                    <i class="fad fa-handshake fa-4x mb-3" style="color: #17a2b8;"></i>
                                    <h5 class="card-title">Procacciatore</h5>
                                    <p class="card-text text-muted">Collaboratore per acquisizione clienti</p>
                                </div>
                            </div>
                        </div>

                        <!-- Card Segnalatore -->
                        <div class="col-md-4">
                            <div class="card card-selectable text-center" v-on:click="selezionaTipologia(3)"
                                style="cursor: pointer; transition: all 0.3s;">
                                <div class="card-body">
                                    <i class="fad fa-bullhorn fa-4x mb-3" style="color: #6c757d;"></i>
                                    <h5 class="card-title">Segnalatore</h5>
                                    <p class="card-text text-muted">Segnalazione contatti e opportunità</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 2: Form in base alla tipologia selezionata -->
                    <div v-else>
                        <!-- Indicatore tipologia selezionata -->
                        <div class="alert alert-info d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <i class="fad" :class="{
                                    'fa-user-tie': agenteSelezionato.LIVELLO === 1,
                                    'fa-handshake': agenteSelezionato.LIVELLO === 2,
                                    'fa-bullhorn': agenteSelezionato.LIVELLO === 3
                                }"></i>
                                <strong class="ml-2">
                                    {{ agenteSelezionato.LIVELLO === 1 ? 'Agente' :
                                        agenteSelezionato.LIVELLO === 2 ? 'Procacciatore' : 'Segnalatore' }}
                                </strong>
                            </div>
                            <button class="btn btn-sm btn-outline-secondary" v-on:click="resetTipologia()">
                                <i class="fal fa-undo"></i> Cambia Tipologia
                            </button>
                        </div>

                        <!-- Form AGENTE (LIVELLO 1) -->
                        <div v-if="agenteSelezionato.LIVELLO === 1">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Codice Agente:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Codice Agente"
                                            v-model="agenteSelezionato.CODICE_AGENTE">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Agente:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Descrizione"
                                            v-model="agenteSelezionato.DESCRIZIONE_AGENTE">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Area di Competenza:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Area di Competenza"
                                            v-model="agenteSelezionato.AREA_DI_COMPETENZA">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Fattore:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Fattore" v-model="agenteSelezionato.FATTORE_AG">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Gettone:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Gettone" v-model="agenteSelezionato.GETTONE_AG">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Data di Nascita:</label>
                                        <DatePicker v-model="agenteSelezionato.DATA_NASCITA" autocomplete="on" placeholder="Seleziona Data" type="text" dim="sm" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Modalità di Pagamento POD:</label>
                                        <select class="form-control form-control-sm" v-model="agenteSelezionato.MODALITA_PAGAMENTO">
                                            <option :value="0">Anticipato - Gettone pieno ogni 13 mesi (default)</option>
                                            <option :value="1">Misto - Anno 1 gettone pieno, poi mensile (10€/mese)</option>
                                        </select>
                                        <small class="text-muted">
                                            <i class="fas fa-info-circle"></i>
                                            <strong>Anticipato:</strong> Pagamento completo (120€) ogni 13 mesi dal primo pagamento.<br>
                                            <strong>Misto:</strong> Primo anno gettone pieno (120€), dal 13° mese pagamento mensile (10€/mese).
                                        </small>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Data Inizio Pagamenti:</label>
                                        <DatePicker v-model="agenteSelezionato.DATA_INIZIO_PAGAMENTI" placeholder="Seleziona Data" dim="sm" />
                                        <small class="text-muted">
                                            <i class="fas fa-info-circle"></i>
                                            Per agenti che hanno acquisito contratti da altre agenzie: le commissioni partono da questa data invece che dalla data inizio fornitura.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="agenteSelezionato.DATA_INIZIO_PAGAMENTI">
                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="flgPrimoAnnoPagato"
                                                v-model="agenteSelezionato.FLG_PRIMO_ANNO_PAGATO"
                                                :true-value="1" :false-value="0">
                                            <label class="custom-control-label" for="flgPrimoAnnoPagato">
                                                <strong>Primo anno già pagato</strong>
                                            </label>
                                        </div>
                                        <small class="text-muted">
                                            <i class="fas fa-info-circle"></i>
                                            Se attivo, il sistema salta direttamente al calcolo del secondo anno (ratei mensili) perché il primo anno è già stato pagato esternamente.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Form PROCACCIATORE (LIVELLO 2) -->
                        <div v-if="agenteSelezionato.LIVELLO === 2">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Codice Procacciatore:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Codice" v-model="agenteSelezionato.CODICE_AGENTE">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Data di Nascita:</label>
                                        <DatePicker v-model="agenteSelezionato.DATA_NASCITA"
                                                    placeholder="Seleziona Data"
                                                    dim="sm" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Nome Procacciatore:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Nome" v-model="agenteSelezionato.DESCRIZIONE_AGENTE">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Form SEGNALATORE (LIVELLO 3) -->
                        <div v-if="agenteSelezionato.LIVELLO === 3">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Codice Segnalatore:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Codice" v-model="agenteSelezionato.CODICE_AGENTE">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Data di Nascita:</label>
                                        <DatePicker v-model="agenteSelezionato.DATA_NASCITA" placeholder="Seleziona Data" dim="sm" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Nome Segnalatore:</label>
                                        <input type="text" class="form-control form-control-sm"
                                            placeholder="Inserisci Nome" v-model="agenteSelezionato.DESCRIZIONE_AGENTE">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaAgente()"
                        :disabled="!agenteSelezionato.LIVELLO">
                        <i class="fa fa-check"></i> Salva
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- MODALE INFO AGENTE -->
    <div class="modal fade" id="popUpInfo" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content shadow-lg rounded-3">
                <div class="modal-header text-white" style="background: linear-gradient(135deg,#3434D9,#34A8D9);">
                    <h5 class="modal-title"><i class="fal fa-info-circle"></i> Dettagli Agente</h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="nav nav-tabs d-flex justify-content-center" id="myTab" role="tablist">
                        <a class="nav-item nav-link active" id="pagamenti-tab" data-toggle="tab" href="#pagamenti"
                            role="tab" aria-controls="pagamenti" aria-selected="true">
                            <i class="fal fa-money-bill"></i> Pagamenti
                            <span class="badge badge-pill badge-light">{{ infoSelezionata.PAGAMENTI ?
                                infoSelezionata.PAGAMENTI.length : '0' }}</span>
                        </a>
                        <a class="nav-item nav-link" id="contratti-tab" data-toggle="tab" href="#contratti" role="tab"
                            aria-controls="contratti" aria-selected="false">
                            <i class="fal fa-file-contract"></i> Contratti
                            <span class="badge badge-pill badge-light">{{ infoSelezionata.CONTRATTI ?
                                infoSelezionata.CONTRATTI.length : '0' }}</span>
                        </a>
                        <a class="nav-item nav-link" id="fatture-tab" data-toggle="tab" href="#fatture" role="tab"
                            aria-controls="fatture" aria-selected="false">
                            <i class="fal fa-file-invoice"></i> Fatture
                            <span class="badge badge-pill badge-light">{{ infoSelezionata.FATTURE ?
                                infoSelezionata.FATTURE.length : '0' }}</span>
                        </a>
                        <a class="nav-item nav-link" id="clienti-tab" data-toggle="tab" href="#clienti" role="tab"
                            aria-controls="clienti" aria-selected="false">
                            <i class="fal fa-users"></i> Clienti Associati
                            <span class="badge badge-pill badge-light">{{ infoSelezionata.CLIENTI ?
                                infoSelezionata.CLIENTI.length : '0' }}</span>
                        </a>
                    </div>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="pagamenti" role="tabpanel"
                            aria-labelledby="pagamenti-tab">
                            <div class="card h-100 border-0 shadow-sm">
                                <div class="card-body" style="max-height: 300px; overflow-y: auto;">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="pag in infoSelezionata.PAGAMENTI" :key="pag.ID_PAGAMENTO"
                                            class="list-group-item">
                                            <strong>{{ filters.formatCash(pag?.IMPORTO) }} €</strong> – {{
                                                filters.formatDate(pag?.DATA_PAGAMENTO) }} -<small class="text-muted">(#{{
                                                pag.ID_PAGAMENTO }})</small>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="contratti" role="tabpanel" aria-labelledby="contratti-tab">
                            <div class="card h-100 border-0 shadow-sm">
                                <div class="card-header bg-white border-bottom">
                                    <div class="btn-group btn-group-sm w-100" role="group">
                                        <button type="button"
                                                class="btn"
                                                :class="filtroContrattiTipo === '' ? 'btn-primary' : 'btn-outline-secondary'"
                                                @click="filtroContrattiTipo = ''">
                                            <i class="fas fa-list"></i> Tutti ({{ infoSelezionata.CONTRATTI ? infoSelezionata.CONTRATTI.length : 0 }})
                                        </button>
                                        <button type="button"
                                                class="btn"
                                                :class="filtroContrattiTipo === 'luce' ? 'btn-warning' : 'btn-outline-warning'"
                                                @click="filtroContrattiTipo = 'luce'">
                                            <i class="fas fa-lightbulb"></i> Luce ({{ infoSelezionata.CONTRATTI ? infoSelezionata.CONTRATTI.filter(c => c.POD && c.POD.length > 0).length : 0 }})
                                        </button>
                                        <button type="button"
                                                class="btn"
                                                :class="filtroContrattiTipo === 'gas' ? 'btn-danger' : 'btn-outline-danger'"
                                                @click="filtroContrattiTipo = 'gas'">
                                            <i class="fas fa-gas-pump"></i> Gas ({{ infoSelezionata.CONTRATTI ? infoSelezionata.CONTRATTI.filter(c => c.PDR && c.PDR.length > 0).length : 0 }})
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body" style="max-height: 300px; overflow-y: auto;">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="contratto in contrattiFiltrati" :key="contratto.ID_CONTRATTO"
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            <div>
                                                <span v-if="contratto.POD">
                                                    <i class="fas fa-lightbulb text-warning"></i>
                                                    <strong> POD:</strong> {{ contratto.POD }}
                                                </span>
                                                <span v-else-if="contratto.PDR">
                                                    <i class="fas fa-gas-pump text-danger"></i>
                                                    <strong> PDR:</strong> {{ contratto.PDR }}
                                                </span>
                                                <br>
                                                <small class="text-muted">
                                                    Cod: {{ contratto.CODICE_CONTRATTO || '—' }} |
                                                    Gettone: {{ contratto.GETTONE_CONTRATTO || 0 }}€
                                                </small>
                                            </div>
                                            <span :class="getStatoBadgeClass(contratto.FLG_ATTIVO)">
                                                {{ getStatoLabel(contratto.FLG_ATTIVO) }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-footer bg-light">
                                    <div class="row text-center g-2">
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-success text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.attivi }}</div>
                                                <div style="font-size: 9px;">Attivi</div>
                                            </span>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-warning text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.chiusiDaFatturare }}</div>
                                                <div style="font-size: 9px;">Chiusi fatt.</div>
                                            </span>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-info text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.attiviDaFatturare }}</div>
                                                <div style="font-size: 9px;">Attivi fatt.</div>
                                            </span>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-primary text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.inAttivazione }}</div>
                                                <div style="font-size: 9px;">In attivaz.</div>
                                            </span>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-danger text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.disattivi }}</div>
                                                <div style="font-size: 9px;">Disattivi</div>
                                            </span>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <span class="badge bg-secondary text-white d-block py-2" style="font-size: 12px;">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioStatiContratti.totali }}</div>
                                                <div style="font-size: 9px;">Totali</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="fatture" role="tabpanel" aria-labelledby="fatture-tab">
                            <div class="card h-100 border-0 shadow-sm">
                                <div class="card-header bg-white border-bottom">
                                    <div class="btn-group btn-group-sm w-100" role="group">
                                        <button type="button"
                                                class="btn"
                                                :class="filtroFattureTipo === '' ? 'btn-primary' : 'btn-outline-secondary'"
                                                @click="filtroFattureTipo = ''">
                                            <i class="fas fa-list"></i> Tutti ({{ infoSelezionata.FATTURE ? infoSelezionata.FATTURE.length : 0 }})
                                        </button>
                                        <button type="button"
                                                class="btn"
                                                :class="filtroFattureTipo === 'luce' ? 'btn-warning' : 'btn-outline-warning'"
                                                @click="filtroFattureTipo = 'luce'">
                                            <i class="fas fa-lightbulb"></i> Luce ({{ infoSelezionata.FATTURE ? infoSelezionata.FATTURE.filter(f => f.POD && f.POD.length > 0).length : 0 }})
                                        </button>
                                        <button type="button"
                                                class="btn"
                                                :class="filtroFattureTipo === 'gas' ? 'btn-danger' : 'btn-outline-danger'"
                                                @click="filtroFattureTipo = 'gas'">
                                            <i class="fas fa-gas-pump"></i> Gas ({{ infoSelezionata.FATTURE ? infoSelezionata.FATTURE.filter(f => f.PDR && f.PDR.length > 0).length : 0 }})
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body" style="max-height: 300px; overflow-y: auto;">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="fattura in fattureFiltrate" :key="fattura.ID_FATTURA"
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            <div>
                                                <span v-if="fattura.POD && fattura.POD.length > 0">
                                                    <i class="fas fa-lightbulb text-warning"></i>
                                                    <strong> POD</strong>
                                                </span>
                                                <span v-if="fattura.PDR && fattura.PDR.length > 0">
                                                    <i class="fas fa-gas-pump text-danger"></i>
                                                    <strong> GAS</strong>
                                                </span>
                                                <br>
                                                <strong>{{ fattura?.NUMERO_FATTURA }}</strong>
                                                <br>
                                                <small class="text-muted">
                                                    Data: {{ filters.formatDate(fattura.DATA_FATTURA) || '—' }}
                                                </small>
                                            </div>
                                            <span class="badge bg-primary text-white">
                                                {{ fattura.IMPORTO ? filters.formatCash(fattura.IMPORTO) + '€' : '—' }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-footer bg-light">
                                    <div class="row text-center">
                                        <div class="col-4">
                                            <span class="badge bg-warning text-white d-block py-2">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioFatture.luce }}</div>
                                                <div style="font-size: 9px;">Luce</div>
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span class="badge bg-danger text-white d-block py-2">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioFatture.gas }}</div>
                                                <div style="font-size: 9px;">Gas</div>
                                            </span>
                                        </div>
                                        <div class="col-4">
                                            <span class="badge bg-secondary text-white d-block py-2">
                                                <div style="font-size: 20px; font-weight: bold;">{{ conteggioFatture.totali }}</div>
                                                <div style="font-size: 9px;">Totali</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="clienti" role="tabpanel" aria-labelledby="clienti-tab">
                            <div class="card h-100 border-0 shadow-sm">
                                <div class="card-body" style="max-height: 300px; overflow-y: auto;">
                                    <ul class="list-group list-group-flush">
                                        <li v-for="cliente in infoSelezionata.CLIENTI" :key="cliente.ID_CLIENTE"
                                            class="list-group-item">
                                            {{ cliente?.DENOMINAZIONE }} <small class="text-muted">(#{{
                                                cliente.CODICE_CLIENTE }})</small>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal"><i class="fal fa-times"></i> Chiudi</button>
                </div>
            </div>
        </div>
    </div>

    <!-- MODALE MODIFICA GETTONI CONTRATTI -->
    <div class="modal fade" id="popUpModificaGettoni" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header" style="background: linear-gradient(135deg,#3434D9,#34A8D9);">
                    <h5 style="color:#fff" class="modal-title">
                        <i class="fal fa-coins fa-fw"></i> Modifica Gettone Contratti
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info">
                        <i class="fas fa-info-circle"></i>
                        Stai modificando il gettone per tutti i contratti dell'agente:
                        <strong>{{ gettoneSelezionato.DESCRIZIONE_AGENTE }}</strong>
                    </div>
                    <div class="form-group">
                        <label>Nuovo Gettone (€):</label>
                        <input type="number" step="0.01" class="form-control"
                               placeholder="Inserisci nuovo gettone"
                               v-model="gettoneSelezionato.GETTONE_AG">
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal">
                        <i class="fal fa-times"></i> Annulla
                    </button>
                    <button class="btn btn-success" @click="salvaAllGettoni()">
                        <i class="fa fa-check"></i> Salva
                    </button>
                </div>
            </div>
        </div>
    </div>





</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import DatePicker from '@/components/utils/DatePicker.vue'

export default {
    name: "Agenti",
    components: {
        Pagine,
        DatePicker,
    },
    data: function () {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                USERNAME: { TYPE: 'TEXT', VALUE: '' },
                DESCRIZIONE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                CODICE_AGENTE: { TYPE: 'TEXT', VALUE: '' },
                AREA_DI_COMPETENZA: { TYPE: 'TEXT', VALUE: '' },
                DOVUTO: { TYPE: 'TEXT', VALUE: '' },
                FATTORE_AG: { TYPE: 'TEXT', VALUE: '' },
                PAGATO: { TYPE: 'COMBO', VALUE: '' },
                LIVELLO: { TYPE: 'COMBO', VALUE: '' },
            },
            arrayAgenti: new Array(),
            agenteSelezionato: {DATA_NASCITA :''},
            gettoneSelezionato: {},
            showFilters: false,
            infoSelezionata: {},
            filtroContrattiTipo: '', // '' = Tutti, 'luce' = Solo Luce, 'gas' = Solo Gas
            filtroFattureTipo: '', // '' = Tutti, 'luce' = Solo Luce, 'gas' = Solo Gas
        }
    },
    methods: {
        moreInfo: function (agente) {
            this.filtroContrattiTipo = ''; // Reset filtro quando si apre il modale
            this.filtroFattureTipo = ''; // Reset filtro fatture
            var modal = utils.openModal('popUpInfo');
            global.utils.get('/dcp/agente/info', { ID_AGENTE: agente.ID_AGENTE }, (response) => {
                this.infoSelezionata = response.data;
            });
        },
        getAgenti: function () {
            global.utils.get('/dcp/agenti', {}, (response) => {
                // Filtra gli agenti che hanno DESCRIZIONE_AGENTE null o vuota
                this.arrayAgenti = response.data.filter(agente =>
                    agente.DESCRIZIONE_AGENTE != null &&
                    agente.DESCRIZIONE_AGENTE != '' &&
                    agente.DESCRIZIONE_AGENTE != undefined
                );

                // Raccogli tutti gli agenti che compiono gli anni
                let agentiCompleanno = [];

                for (let i = 0; i < this.arrayAgenti.length; i++) {
                    if (this.arrayAgenti[i].IS_BIRTHDAY == true) {
                        agentiCompleanno.push(this.arrayAgenti[i].DESCRIZIONE_AGENTE);
                    }
                }

                // Mostra messaggio in base al numero di compleanni
                if (agentiCompleanno.length === 1) {
                    utils.alert.info("🎂 Oggi è il compleanno di " + agentiCompleanno[0] + "!");
                } else if (agentiCompleanno.length > 1) {
                    utils.alert.info("🎉 Oggi è il compleanno di " + agentiCompleanno.length + " agenti: " + agentiCompleanno.join(", ") + "!");
                }
            });
        },
        creaAgente: function () {
            this.agenteSelezionato = { ID_AGENTE: 0 };
            var modal = utils.openModal('popUpAgente');
        },
        esportaAgenti: function () {
            var url = utils.BASE_API + "dcp/report?ID_REPORT=1&SESSION_TOKEN=" + utils.SESSION_TOKEN + "&FORMATO=2&ORD=1";
            window.open(url);
        },
        esportaDettaglioAgente: function (agente) {
            var url = utils.BASE_API + "dcp/report?ID_REPORT=2&ID_AGENTE=" + agente.ID_AGENTE + "&SESSION_TOKEN=" + utils.SESSION_TOKEN + "&FORMATO=2&ORD=1";
            window.open(url);
        },
        modificaAgente: function (agente) {
            // Salva le date originali
            const dataNascitaOriginale = agente.DATA_NASCITA;
            const dataInizioPagamentiOriginale = agente.DATA_INIZIO_PAGAMENTI;

            this.agenteSelezionato = utils.clone(agente);

            if(this.agenteSelezionato.FATTORE_AG == null){
                this.agenteSelezionato.FATTORE_AG = '0.00';
            }

            // Inizializza date vuote per permettere ai DatePicker di montarsi
            this.agenteSelezionato.DATA_NASCITA = '';
            this.agenteSelezionato.DATA_INIZIO_PAGAMENTI = '';

            utils.openModal('popUpAgente');

            // Aspetta che i DatePicker siano montati, poi assegna i valori
            setTimeout(() => {
                // Se DATA_NASCITA è null o vuota, imposta 01/01/1901
                if(dataNascitaOriginale == null || dataNascitaOriginale == ''){
                    this.agenteSelezionato.DATA_NASCITA = '01/01/1901';
                } else {
                    this.agenteSelezionato.DATA_NASCITA = this.filters.formatDate(dataNascitaOriginale);
                }
                // Gestione DATA_INIZIO_PAGAMENTI
                if(dataInizioPagamentiOriginale != null && dataInizioPagamentiOriginale != '' && dataInizioPagamentiOriginale != '0000-00-00'){
                    this.agenteSelezionato.DATA_INIZIO_PAGAMENTI = this.filters.formatDate(dataInizioPagamentiOriginale);
                }
            }, 100);
        },
        deleteAgente: function (agente) {
            utils.alert.confirm("Sei sicuro di voler eliminare l'agente selezionato?", () => {
                global.utils.delete('/dcp/agente', { ID_AGENTE: agente.ID_AGENTE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getAgenti();
                    }
                });
            }, this.$root);
        },
        salvaAgente: function () {
            if(this.agenteSelezionato.LIVELLO == 1){
                this.agenteSelezionato.FATTORE_AG = this.filters.formatWithCommas(this.agenteSelezionato.FATTORE_AG)
            }
            if (this.agenteSelezionato.CODICE_AGENTE == undefined || this.agenteSelezionato.CODICE_AGENTE == '') {
                utils.alert.warning("Inserire almeno il codice e la descrizione");
                return;
            }
            if (this.agenteSelezionato.DESCRIZIONE_AGENTE == undefined || this.agenteSelezionato.DESCRIZIONE_AGENTE == '') {
                utils.alert.warning("Inserire almeno il codice e descrizione agente");
                return;
            }
            if (this.agenteSelezionato.ID_AGENTE > 0) {
                global.utils.put('/dcp/agente', this.agenteSelezionato, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getAgenti();
                        utils.closeModal('popUpAgente');
                    }
                });
            }
            else {
                global.utils.post('/dcp/agente', this.agenteSelezionato, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getAgenti();
                        utils.closeModal('popUpAgente');
                    }
                });
            }
        },
        selezionaTipologia(livello) {
            this.agenteSelezionato.LIVELLO = livello;

            // Reset campi non necessari in base al livello
            if (livello === 2 || livello === 3) {
                this.agenteSelezionato.AREA_DI_COMPETENZA = null;
                this.agenteSelezionato.FATTORE_AG = null;
            }
        },

        resetTipologia() {
            this.agenteSelezionato.LIVELLO = null;
        },

        getStatoLabel: function (flgAttivo) {
            // Mappa il valore numerico al testo dello stato
            switch (flgAttivo) {
                case 1: return 'Attivo';
                case 2: return 'Chiuso da fatturare';
                case 3: return 'Attivo da fatturare';
                case 4: return 'In attivazione';
                case 5: return 'Disattivo';
                default: return 'Sconosciuto';
            }
        },

        getStatoBadgeClass: function (flgAttivo) {
            // Mappa il valore numerico alla classe badge
            switch (flgAttivo) {
                case 1: return 'badge bg-success text-white'; // Attivo - verde
                case 2: return 'badge bg-warning text-white'; // Chiuso da fatturare - giallo
                case 3: return 'badge bg-info text-white'; // Attivo da fatturare - azzurro
                case 4: return 'badge bg-primary text-white'; // In attivazione - blu
                case 5: return 'badge bg-danger text-white'; // Disattivo - rosso
                default: return 'badge bg-secondary text-white'; // Sconosciuto - grigio
            }
        },

        modificaAllGettoni: function (agente) {
            // Copia i dati dell'agente selezionato
            this.gettoneSelezionato = utils.clone(agente);
            // Apri il modale
            utils.openModal('popUpModificaGettoni');
        },

        salvaAllGettoni: function () {
           
            if (!this.gettoneSelezionato.GETTONE_AG || this.gettoneSelezionato.GETTONE_AG <= 0) {
                utils.alert.warning("Inserire un valore valido per il gettone");
                return;
            }

            utils.alert.confirm("Sei sicuro di voler aggiornare il gettone di ogni contratto associato a questo agente?", () => {
                global.utils.put('/dcp/agente/gettoni', {
                    ID_AGENTE: this.gettoneSelezionato.ID_AGENTE,
                    GETTONE_AG: this.gettoneSelezionato.GETTONE_AG
                }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio || "Gettoni aggiornati con successo");
                        this.getAgenti(); // Ricarica la lista agenti
                        utils.closeModal('popUpModificaGettoni');
                    } else {
                        utils.alert.error(response.messaggio || "Errore durante l'aggiornamento dei gettoni");
                    }
                });
            }, this.$root);
        },

    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayAgenti, this.search);
            return arr;
        },
        contrattiFiltrati() {
            if (!this.infoSelezionata.CONTRATTI) return [];

            if (this.filtroContrattiTipo === 'luce') {
                return this.infoSelezionata.CONTRATTI.filter(c => c.POD && c.POD.length > 0);
            } else if (this.filtroContrattiTipo === 'gas') {
                return this.infoSelezionata.CONTRATTI.filter(c => c.PDR && c.PDR.length > 0);
            }
            return this.infoSelezionata.CONTRATTI;
        },
        conteggioStatiContratti() {
            const contratti = this.contrattiFiltrati;
            return {
                attivi: contratti.filter(c => c.FLG_ATTIVO === 1).length,
                chiusiDaFatturare: contratti.filter(c => c.FLG_ATTIVO === 2).length,
                attiviDaFatturare: contratti.filter(c => c.FLG_ATTIVO === 3).length,
                inAttivazione: contratti.filter(c => c.FLG_ATTIVO === 4).length,
                disattivi: contratti.filter(c => c.FLG_ATTIVO === 5).length,
                totali: contratti.length
            };
        },
        fattureFiltrate() {
            if (!this.infoSelezionata.FATTURE) return [];

            if (this.filtroFattureTipo === 'luce') {
                return this.infoSelezionata.FATTURE.filter(f => f.POD && f.POD.length > 0);
            } else if (this.filtroFattureTipo === 'gas') {
                return this.infoSelezionata.FATTURE.filter(f => f.PDR && f.PDR.length > 0);
            }
            return this.infoSelezionata.FATTURE;
        },
        conteggioFatture() {
            const fatture = this.fattureFiltrate;
            const tutteFatture = this.infoSelezionata.FATTURE || [];
            return {
                luce: tutteFatture.filter(f => f.POD && f.POD.length > 0).length,
                gas: tutteFatture.filter(f => f.PDR && f.PDR.length > 0).length,
                totali: tutteFatture.length
            };
        },
    },
    created: function () {
        this.getAgenti();
    },
}
</script>
<style scoped>
/* Override per rimuovere i bordi dai th della tabella Agenti */
.isprint-grid-thead tr th span {
    border-right: none !important;
    border: none !important;
}

.offcanvas-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .15);
    opacity: 0;
    visibility: hidden;
    transition: opacity .2s ease, visibility .2s ease;
    z-index: 1040;
}

.offcanvas-backdrop.show {
    opacity: 1;
    visibility: visible;
}

.offcanvas-panel {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100vh;
    width: 88%;
    max-width: 420px;
    background: #fff;
    box-shadow: -6px 0 24px rgba(0, 0, 0, .15);
    z-index: 1050;
    display: flex;
    flex-direction: column;
    transition: right .25s ease;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.offcanvas-panel.open {
    right: 0;
}

.offcanvas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .75rem 1rem;
    border-bottom: 1px solid #eee;
}

.offcanvas-body {
    flex: 1;
    padding: 1rem;
    overflow-y: auto;
}

.card-selectable {
    border: 2px solid #e0e0e0;
    transition: all 0.3s ease;
}

.card-selectable:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    border-color: #3434D9;
}

.card-selectable:active {
    transform: translateY(-2px);
}

@media (max-width: 767px) {
    .kt-portlet__head {
        height: 0 !important;
        overflow: hidden;
        margin: 0 !important;
        padding: 0 !important;
    }

    .isprint-grid-container {
        margin-top: 10px !important;
    }
}

/* Quando la larghezza della finestra è maggiore o uguale a 1229px */
@media (min-width: 1092px) {
    .isprint-grid-container {
        margin-top: 20px;
        width: auto;
        table-layout: auto;
    }
}

/* Quando la larghezza della finestra è inferiore a 1396px */
@media (max-width: 1091px) {
    .isprint-grid-container {
        margin-top: 100px;
    }
}

/* Colori per colonne Gas e Luce */
.bg-gas {
    background-color: rgba(255, 0, 0, 0.1) !important;
}

.bg-luce {
    background-color: rgba(255, 255, 0, 0.1) !important;
}

.mobile-page-title {
    padding: 15px;
    background: linear-gradient(135deg, #3434D9, #34A8D9);
    color: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
    margin-bottom: 0;
}

.mobile-page-title h4 {
    margin: 0;
    color: white;
}

.mobile-page-title i {
    margin-right: 8px;
}
</style>
